import { DeleteConfirmDialog } from './delete-confirm-dialog.component';

export type AdSetsDeleteConfirmDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  adSetName: string | null;
};

export const AdSetsDeleteConfirmDialog = ({
  onClose,
  onConfirm,
  loading,
  adSetName,
}: AdSetsDeleteConfirmDialogProps) => {
  const message = `This action will delete Ad Set${adSetName ? ` "${adSetName}".` : ''}`;

  return (
    <DeleteConfirmDialog
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      message={message}
    />
  );
};
